import React, { Fragment, useMemo, useCallback } from "react";
import { TableFooter } from "@mui/material";
import { StyledTableRow, StyledTableCell } from "./styledComponent";
import { createInitialFooter, footerCalculation } from "./utils";
import { formatNumberWithCommas } from "../../../../../utils/formatNumberWithComma";

const TblFooter = ({ columns = [], footerColums = [], exeColms = [], data = [], isActionable = false }) => {

    const WEEKDAYS = useMemo(() => ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], []);

    const footerInitialArray = useMemo(() => {
        if (!Array.isArray(columns) || columns.length === 0) return [];
        const cols = createInitialFooter(columns, footerColums);
        const index = cols.findIndex(col => col.label === footerColums[0]);
        if (index !== -1 && index !== 0) {
            cols[0] = { ...cols[0], value: "Total" }
        }
        return cols;
    }, [columns, footerColums]);

    const footer = useMemo(() => {
        if (!Array.isArray(footerInitialArray) || footerInitialArray.length === 0) return [];
        if (!Array.isArray(data) || data.length === 0) return [];
        return footerCalculation(footerInitialArray, data, exeColms);
    }, [footerInitialArray, data, exeColms])

    const getRowTotal = useCallback((row) => {
        let sum = 0;
        row.forEach((item) => {
            if (WEEKDAYS.includes(item.label)) {
                sum += Number(item.value) || 0;
            }
        })
        return sum;
    }, [WEEKDAYS]);

    return (
        <Fragment>
            {footer.length > 0 && (
                <TableFooter sx={{ position: 'sticky', bottom: -1, zIndex: 999 }}>
                    <StyledTableRow>
                        {footer.map((item, index) => (
                            item.label === "Total" ? (
                                <StyledTableCell key={`footerCell${index}`} colSpan={item.colSpan}>
                                    {formatNumberWithCommas(getRowTotal(footer))}
                                </StyledTableCell>
                            ) : (
                                <StyledTableCell key={`footerCell${index}`} colSpan={item.value === 'Total' && isActionable ? item.colSpan + 1 : item.colSpan}>
                                    {typeof item.value === "number" ? formatNumberWithCommas(item.value) : item.value}
                                </StyledTableCell>
                            )
                        ))}
                        {isActionable && <StyledTableCell colSpan={2}></StyledTableCell>}
                    </StyledTableRow>
                </TableFooter>
            )}
        </Fragment>

    )
}

export default React.memo(TblFooter);

